if(!customElements.get('tiles-slider')) {
  class TilesSlider extends HTMLElement {
    constructor() {
      super();
      this.enabled = this.dataset.enabled || false;
    }

    initSlider() {
      this.slider = new Flickity(this, {
        wrapAround: true,
        pageDots: true,
        prevNextButtons: false,
        imagesLoaded: true,
        adaptiveHeight: true,
        cellAlign: 'left'
      });
    }

    connectedCallback() {
      if(!Flickity) return;
      if(!this.enabled && window.innerWidth > 767) return;

      window.addEventListener('resize', () => { 
        if(window.innerWidth > 767) return;
        if(this.slider) return;

        this.initSlider();
      });

      this.initSlider();
    }
  }

  customElements.define('tiles-slider', TilesSlider);
}
